<template>
    <div class="page-article SlimContainerWithTopMargin">
        <v-container>
            <page-parts :items="items"/>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "SlimContainerWithTopMargin",

    props: ['items'],
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/wrappers/SlimContainerWithTopMargin"
</style>